import { createFormActions, createInput, createSelect, createTextArea } from ":ui/form";

export function createRequestFromInputs() {
  const TableNumber = createSelect("", {
    required: true,
  });
  const Mobile = createInput(null, {
    required: false,
    validators: (value) => {
      if (value == undefined) {
        // return { "is required": true };
        return undefined;
      }
      if (!String(value).startsWith("05")) {
        return { "must start with 05": true };
      }
      return undefined;
    },
  });
  const Description = createTextArea("", {
    required: true,
  });

  const Actions = createFormActions({
    TableNumber,
    Mobile,
    Description,
  });

  return {
    Actions,
    TableNumber,
    Mobile,
    Description,
  };
}
